<template>
    <div id="notes-component">
        <div class="animated fadeIn">
            <div class="row">
                <ul class="notes-history">
                    <li v-for="nota of notas" :key="nota.id" v-if="nota.reluser">
                        <div class="message-data" :class="{alignRight: nota.reluser.id!==nota.user_id}">
                            <span v-if="" class="message-data-name">{{ nota.reluser.name }}</span>
                            <span class="message-data-time">{{ nota.created_at | duration('humanize', true) }}</span>
                        </div>
                        <div class="message" :class="{myMessage: nota.reluser.id===nota.user_id, otherMessage: nota.reluser.id!==nota.user_id, floatRight: nota.reluser.id!==nota.user_id}">
                            {{ nota.note }}
                        </div>
                    </li>
                </ul>
            </div>
            <form class="viewNote">
                <div class="row">
                    <div class="col-12 col-sm-12">
                        <textarea data-textarea="on" data-name-input="Texto de la nota" v-model="addNote.note" name="note" id="note" placeholder="Nota" class="al-inputs required"></textarea>
                    </div>
                    <div class="col-12 col-sm-3 offset-sm-9">
                        <button id="dyn-button" class="btn btn-primary addNote" type="button" v-on:click="guardar()">{{ tituloBtn }}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import {notesService} from "../../Services/Notes.service";
import {myMixins} from "../mixins/myMixins";

export default {
    name: 'notes',
    props: {
        user_id: {
            type: Number,
            required: false
        },
        role_id: {
            type: Number,
            required: false
        },
        supplier_id: {
            type: Number,
            required: false
        }
    },
    mixins: [myMixins],
    data() {
        return {
            modificar: false,
            addNote: {
                id: '',
                note: '',
                user_id: this.user_id,
                role_id: this.role_id,
                supplier_id: this.supplier_id,
            },
            notas: [],
            selectNotes: {
                where: [{
                    field: 'supplier_id',
                    operator: '=',
                    value: this.supplier_id,
                }, {
                    field: 'role_id',
                    operator: '=',
                    value: this.role_id,
                }],
            },
            tituloBtn: 'Agregar Nota',
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await notesService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('viewNote');
            if (respVal) {
                this.disableSubmitBtn(true);
                //DINAMICAMENTE ASIGNAMOS EL VALOR DEL CAMPO A GUARDAR
                if (this.modificar) {
                    resp = await notesService.updateOne(this.addNote.id, this.addNote);
                } else {
                    resp = await notesService.saveOne(this.addNote);
                }
                this.addNote.note = '';
                this.setEmpty();
                this.getAlert(resp.process, true);
                await this.index();
                this.disableSubmitBtn(false);
            }
            this.modificar = false;
        },
        async index() {
            this.notas = await notesService.getMany(this.selectNotes);
        },
        setEmpty() {
            this.addNote = {
                id: '',
                note: '',
                user_id: this.user_id,
                role_id: this.role_id,
                supplier_id: this.supplier_id,
            };
        }
    },
    mounted() {
        this.index();
    }
}
</script>
